<template>
  <div class="abilitySwan">
    <div>
      <div class="sparkTitle fz18 bl">
        鸿鹄计划之金牌合伙人
      </div>
      <div class="c666" style="margin-top: 16px;">
        秉承“做保险人一生的事业伙伴”的企业使命，壹心保代集中最优势资源，结合独立代理人政策趋势，建立“金牌合伙人俱乐部”，实现共同富裕的梦想。壹心保代以金牌合伙人为切入点，全力打造新时代保险企业家；从领导力建设、企业家精神、营销体系训练及管理案例复盘，聚焦于高效率组织建设，和全体代理人共同成长、共享未来。
      </div>
    </div>
    <div>
      <div class="sparkTitle fz18 bl">
        鸿鹄计划之领袖培养计划
      </div>
      <div class="c666" style="margin-top: 16px;">
        领袖培养计划是壹心保代的一项长期战略投入，专为打造一批领袖级行业精英而制定。公司立足人才培养，锁定国际标准，匹配职业生涯，对标发达市场，对每位优秀代理人斥资百万，用时六年，倾力支持，全程陪伴他们走向职业巅峰。
      </div>
    </div>
    <div>
      <img src="../assets/images/picture_31.png" alt="">
    </div>

  </div>
</template>

<script>
  export default {
    name: 'abilitySwan',
    components: {},
    data() {
      return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .abilitySwan {
    width: 1024px;
    margin: 0 auto;
    &>div {
      margin-top: 40px;

      img {
        width: 100%;
      }
    }
  }
</style>